import classNames from "classnames";

import Timeline from "@/components/data-display/timeline";
import {
  ORDER_STATUS,
  PAYMENT_STATUS,
} from "@/utils/constants/order.constants.js";
import { formatStatus } from "@/utils/helpers";

export const OrderTracking = ({ data }) => {
  return (
    <div className="rounded-[0.75rem] border border-[#EBEEF2]">
      <div className="items-center justify-between p-6 md:flex">
        <div className="mb-1 md:mb-0">
          <p className="mb-1 text-lg font-semibold">
            Order ID{" "}
            <span className="text-primary-400">{data?.order_number}</span>
          </p>
          <p className="text-grayDisplay-400">{data?.order_date}</p>
        </div>

        <div className="md:text-end">
          <p
            className={classNames(
              {
                "text-order-cancelled":
                  data?.delivery_status === ORDER_STATUS.cancelled,
                "text-order-processing":
                  data?.delivery_status === ORDER_STATUS.processing,
                "text-order-delivered":
                  data?.delivery_status === ORDER_STATUS.delivered,
                "text-order-shipped":
                  data?.delivery_status === ORDER_STATUS.shipped,
                "text-order-placed":
                  data?.delivery_status === ORDER_STATUS.orderPlaced,
                "text-order-returned":
                  data?.delivery_status === ORDER_STATUS.returned,
              },
              "mb-1 font-semibold"
            )}
          >
            {formatStatus(data?.delivery_status)}
          </p>
          <p className="text-grayDisplay-400">
            Payment Status:{" "}
            <span
              className={classNames(
                {
                  "text-payment-paid":
                    data?.payment_status === PAYMENT_STATUS.paid,
                  "text-payment-unpaid":
                    data?.payment_status === PAYMENT_STATUS.unpaid,
                },
                "font-semibold"
              )}
            >
              {formatStatus(data?.payment_status)}
            </span>
          </p>
        </div>
      </div>

      <div className="border-b border-[#EBEEF2]" />

      <div className="p-4 sm:p-6">
        <Timeline timeLineData={[...data.order_history].reverse()} />
      </div>
    </div>
  );
};
